import React, { forwardRef, useMemo } from 'react'
import { useSelector } from 'react-redux';
import { Table } from 'Components/uiControls';
import { useIntl } from 'react-intl';
import _ from 'lodash';

import LocalOfferIcon from '@mui/icons-material/LocalOffer';

const byVehicleGroups = forwardRef((props, ref) => {
    const { messages } = useIntl();
    const {
        loading,
        columns,
        data,
        changeIdsCallback,
        searchText,
        onSelectedItems,
        onChangeColumns,
        onChangeSort,
        sort,
        onChangeRowsPerPage,
        rowsPerPage,
        moduleUnitSettings,
        columnsToExportPFF
    } = props;

    const { filters } = useSelector(state => state.fleetMainRedux);

    const getNonDuplicateElements = (elements) => {
        const nonDuplicateElements = [];

        //add elements only once
        elements.forEach((element) => {
            if (nonDuplicateElements.findIndex(item => item.id == element.id) < 0) {
                nonDuplicateElements.push(element)
            }
        });

        return nonDuplicateElements;
    };

    const tagData = useMemo(() => {
        let untaggedTag = { id: -1, label: messages['untagged'], color: "000000" };
        let tags = [];

        //We need to show the untagged section, so we need to add a virtual "Untagged" tag to the units without tags
        let currentData = data.map(item => {
            if (!item.tags || !item.tags?.length) {
                return { ...item, tags: [{ ...untaggedTag }], filterTag: untaggedTag.id };
            } else {
                return { ...item, tags: item?.tags?.filter(t => t?.id != -1) };
            }
        });
        let tagData = [];

        let untaggedFilter = false;
        if (filters?.tags && filters?.tags?.length && filters?.tags?.filter(t => t?.id == -1)?.length) {
            untaggedFilter = true;
        }

        //Add the untagged tag only when untagged is selected in filters or not tags filters or all tags is selected
        if (untaggedFilter || !filters?.tags?.length || filters?.tags?.filter(t => t?.id == -99)?.length) {
            tags.push({ ...untaggedTag });
        }

        //Put all tags in one array
        currentData.forEach(x => {
            if (x?.tags) tags.push(...x.tags);
        });

        //Remove repeated tags
        if (filters?.tags && filters?.tags?.length && !filters?.tags?.find(t => (t?.id == -1 || t?.id == -99))) {
            tags = [...filters?.tags];
        } else {
            tags = tags.filter((value, index) => tags.findIndex(value2 => _.isEqual(value2, value)) === index);
        }
        tags = getNonDuplicateElements(tags);

        //Filter only the units with the tags selected
        tags.forEach(tag => {
            currentData.forEach(item => {
                if (item.tags?.find(t => t?.id == tag?.id)) {
                    tagData.push({ ...item, filterTag: tag.id });
                } else if (tag?.id == -1 && item.tags.length == 0) {
                    item.tags.push(tag);
                    tagData.push({ ...item, filterTag: tag.id });
                }
            })
        });

        return tagData;
    });

    return (

        <Table
            ref={ref}
            keyColumn="id"
            loading={loading}
            topheight={!moduleUnitSettings ? 180 : 238}
            columns={columns}
            data={tagData}
            onSelectedItems={onSelectedItems}
            onChangeDisplayData={(displayData) => {
                changeIdsCallback(displayData, "id")
            }}
            grouping
            groupingValueToCompare={"filterTag"}
            groupingArea={(tag, item) => {
                let newTag = item.tags.find(x => x.id == tag);
                return (
                    <div style={{ background: "#f7f7f7", padding: 16, width: '100%' }}>
                        <div style={{ display: 'flex' }} >
                            <div>
                                <LocalOfferIcon style={{ fontSize: "18px", color: "#" + (newTag.color || '808080') }} />
                            </div>
                            <div style={{ paddingLeft: 10 }}>
                                <span className="separatorSpan" >{`${newTag?.id == -1 ? messages['untagged'] : newTag.label}`}</span>
                            </div>
                        </div>
                    </div>
                )
            }}
            searchText={searchText}
            exportOrientation='landscape'
            exportName='fleetTags'
            onChangeColumns={onChangeColumns}
            onChangeSort={onChangeSort}
            sort={sort}
            onChangeRowsPerPage={onChangeRowsPerPage}
            rowsPerPage={rowsPerPage}
            hideAllInPagination={true}
            columnsToExportPFF={columnsToExportPFF}
        />
    )
})

export default byVehicleGroups;